module.exports = __webpack_public_path__ + "static/media/uploadarrow.2cd2d17b.svg";